import React from "react";
import styles from "./SubscriptionLimit.module.scss";
import { Intent, ProgressBar, Spinner } from "@blueprintjs/core";
import classnames from "classnames";
import { useSubscriptionLimit } from "./hooks";

function SubscriptionLimit({ className, type }) {
  const {
    usage,
    limit,
    progress,
    loading,
    showAlert,
    isPartnered,
    description
  } = useSubscriptionLimit(type);

  if (loading) {
    return (
      <div className={classnames(styles.addOnSpinner, className)}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className={classnames(styles.addOnWrapper, className)}>
      <div className={styles.addOnHeader}>
        <div>Available Limit</div>
        {showAlert && <div className={styles.btnAddOn}>Buy Addons</div>}
      </div>
      <div className={styles.description}>{description}</div>
      {!isPartnered && (
        <>
          <div className={styles.videoInfo}>
            {usage}/{limit}
          </div>
          <ProgressBar
            stripes={false}
            animate={false}
            intent={Intent.PRIMARY}
            value={progress}
          />
        </>
      )}

      {showAlert && (
        <div className={styles.alertText}>
          You are exceeding your monthly limits Buy Addons or your package will
          be changed.
        </div>
      )}
    </div>
  );
}

export default SubscriptionLimit;
